import { useState, useEffect } from 'react';
import { API_URL } from '@/utils/api';

/**
 * Hook para detectar estado de conexión online/offline
 * @returns {boolean} true si hay conexión, false si está offline
 */
export function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [wasOffline, setWasOffline] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);

            // Si estaba offline, disparar evento de reconexión
            if (wasOffline) {
                console.log('🟢 Conexión restaurada - Iniciando sincronización');
                window.dispatchEvent(new CustomEvent('connection-restored'));
                setWasOffline(false);
            }
        };

        const handleOffline = () => {
            setIsOnline(false);
            setWasOffline(true);
            console.log('🔴 Sin conexión - Modo Offline activado');
            window.dispatchEvent(new CustomEvent('connection-lost'));
        };

        // Escuchar eventos del navegador
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Verificación periódica (cada 30 segundos)
        const interval = setInterval(async () => {
            try {
                // Intentar fetch al backend
                const baseUrl = API_URL.replace('/api', '');
                const response = await fetch(`${baseUrl}/health`, {
                    method: 'GET',
                    cache: 'no-cache'
                });

                if (response.ok && !isOnline) {
                    handleOnline();
                }
            } catch (error) {
                if (isOnline) {
                    handleOffline();
                }
            }
        }, 30000);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            clearInterval(interval);
        };
    }, [isOnline, wasOffline]);

    return isOnline;
}
